import React from 'react';
import { LockIcon, PlusIcon } from '../../../assets/icons/icons';
import { BackButton } from '../../ui/BackButton/BackButton';
import { Button } from '../../ui/Button/Button';
import styles from './PageHeader.module.scss';

interface PageHeaderProps {
    stopListCount: number;
    onOpenStopList: () => void;
    onCreateProject: () => void;
}

export function PageHeader({ stopListCount, onOpenStopList, onCreateProject }: PageHeaderProps) {
    return (
        <div className={styles.head}>
            {/* <BackButton /> */}

            <h1>Проекты</h1>

            <div className={styles.spacer} />

            <div className={styles.actions}>
                <Button
                    variant="stoplist"
                    icon={<LockIcon />}
                    badge={stopListCount}
                    title="Сайты, исключённые из поиска предложений"
                    onClick={onOpenStopList}
                >
                    Стоп-лист сайтов
                </Button>

                <Button variant="primary" icon={<PlusIcon />} onClick={onCreateProject}>
                    Новый проект
                </Button>
            </div>
        </div>
    );
}
